import React from "react"
import {useLocation, useNavigate} from "react-router-dom"
import {useForm} from '@mantine/form';
import {TextInput} from '@mantine/core';
import { isVertaaensinHost } from "../utils/runtimeOverrides"

interface SigninOverlayProps {
	handleSignin: () => void;
}

const SigninOverlay = (props: SigninOverlayProps) => {
	const navigate = useNavigate()
	const {state} = useLocation();
	const form = useForm({initialValues: {username: '', password: ''}})
	const [showWarning, setShowWarning] = React.useState(false)
	const primaryCtaClass = isVertaaensinHost()
		? "bg-[#f58423] hover:bg-[#f58423] text-white"
		: "bg-[#0F6CBD] hover:bg-[#0c589a] text-white"

	const verifyCredentials = (): void => {
		let validCredentials = false

		const credentials: string = `${form.values.username}:${form.values.password}`

		if (
			[process.env.REACT_APP_CREDENTIALS2].includes(credentials)
		) {
			validCredentials = true
		}

		if (validCredentials) {
			setShowWarning(false)
			props.handleSignin()
		} else {
			setShowWarning(true)
		}
	}

	return (
		<div className="flex flex-col items-center justify-center">
			<div className="w-full p-4">
				<div className="m-auto vakuutuslaskuri-logo"></div>
			</div>
			<div
				className="flex flex-col flex-1 items-stretch justify-center max-w-xl mt-4 sm:mt-0 m-auto px-2 sm:px-6 lg:px-8 sm:p-10 bg-white">
				Please sign in to continue.
			</div>
			<div className="mt-6 sm:mt-0 flex flex-col items-center max-w-sm justify-center">
				<TextInput
					label="Username"
					placeholder="Username"
					{...form.getInputProps('username')}
				/>
				<TextInput
					mt="md"
					label="Password"
					placeholder="Password"
					{...form.getInputProps('password')}
				/>
				<div className="my-4 min-h-[25px] text-red-600 text-center ">
					{showWarning && <span>Invalid credentials</span>}
				</div>
				<button
					onClick={() => verifyCredentials()}
					className={`${primaryCtaClass} mx-auto text-center ring-0! focus:ring-offset-0 outline:none duration-200 border py-3 px-8 font-semibold text-md rounded-md transition-all`}>
					Sign in
				</button>
			</div>
		</div>
	)
}

export default SigninOverlay
